
import { RequireKitResponse } from "@/models/entities/storage/cart/cartKit.interface";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class RequiredKit extends Vue {
  @Prop({ required: true }) private kit: RequireKitResponse;
  @Prop({ required: true }) private elementsList: StorageElements[];
  private totCategory = 0;
  private addToTotalNoVat = 0;
  private kitNumber = 0;
  private requireKit = false;
  private requirePrice = false;
  private mercedes = false;

  @Watch("kit.kitNumber")
  kitChanged(): void {
    this.kitNumber = parseInt(this.kit.kitNumber);
  }

  mounted(): void {
    this.totCategory = this.kit.totCategory;
    this.addToTotalNoVat = this.kit.addToTotalNoVat;
    this.kitNumber = parseInt(this.kit.kitNumber);
    this.requireKit = this.kit.requireKit;
    this.requirePrice = this.kit.requirePrice;
    this.checkMercedes();
  }

  private checkValue(): void {
    if (this.kitNumber <= 0) this.kitNumber = 1;
    this.addToTotalNoVat = this.kitNumber * 14;
    // this.addToTotalNoVat = (this.totCategory % 4) * 14;
    this.emitChange();
  }

  private emitChange(): void {
    const values: RequireKitResponse = {
      totCategory: this.totCategory,
      addToTotalNoVat: this.addToTotalNoVat,
      kitNumber: this.kitNumber.toString(),
      requireKit: this.requireKit,
      requirePrice: this.requirePrice,
    };
    this.$emit("changeKit", values);
  }

  private checkMercedes(): void {
    this.elementsList.forEach((value, index) => {
      if (value.brand == "MERCEDES") {
        this.mercedes = true;
      } else {
        this.mercedes = false;
      }
    });
  }
}
